import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Modal from 'components/UI/Modal/Modal';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ConfigTypes from 'config/ConfigTypes';
import WishList from "components/Cart/WishList/WishList";
import CartList from "components/Cart/CartList/CartList";

import './CartListPage.scss'

const CartListPage = observer(
    class CartListPage extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                modalOpened: false,
                formErrors: {},
            }
        }

        initData = (prevProps) => {
            const { shopForm } = this.props.cartObjects;
            if (prevProps.cartObjects.shopForm != shopForm) {
                //this.setState({ modalOpened: true, shopForm: shopForm });
                this.setState({ modalOpened: shopForm, shopForm: shopForm });
            }
        }

        closeModal = () => {
            this.setState({ modalOpened: false, shopForm: null });
            this.props.updateCartObjects({ shopForm: null });
        }

        showForm = () => {
            switch (this.state.shopForm) {
                case ConfigTypes.WISHLIST:
                    return (<WishList onCloseModal={this.closeModal} />)
                case ConfigTypes.CART:
                    return (<CartList onCloseModal={this.closeModal} />)
                default:
                    return;
            }
        }

        componentDidUpdate(prev) {
            this.initData(prev);
        }

        componentDidMount() {

        }

        render() {
            return (
                <div className="cartpage">
                    <Modal className="cartlistpage-modal" open={this.state.modalOpened}
                        onClose={() => this.setState({ modalOpened: false })}>
                        <div className="cartlistpage-close" onClick={this.closeModal}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        {this.state.shopForm && this.showForm()}
                    </Modal>
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartListPage))));


